<template>
    <div class="container">
      <div class="row align-items-center text-center text-md-left">
        <div class="col-12 col-md-4 mb-3 mb-md-0">
          <img class="logo img-fluid" src="https://sifc3.iea.edu.mx/logos/img-escudoiea.png" alt="IEA">
        </div>
        <div class="col-12 col-md-8">
          <div class="titulo">
            <b>Sistema Integral de Formación Continua</b><br>
            <b>Consulta Código QR</b>
          </div>
        </div>
      </div>
  
      <br>
      <br>
      <div v-if="error" class="alert alert-danger">
        <b>No se pudo validar el documento.</b>
      </div>
  
      
      <div v-if="registro" class="col">
        <div class="header"><b>Datos del Participante</b></div>
        <div class="info">
          <p><b>Primer Apellido:</b> {{ registro.apellidop }}</p>
          <p><b>Segundo Apellido:</b> {{ registro.apellidom }}</p>
          <p><b>Nombre(s):</b> {{ registro.nombres }}</p>
          <p><b>CURP:</b> {{ registro.usuario }}</p>
        </div>
  
        <div class="header"><b>Institución Formadora</b></div>
        <div class="info">
          <p><b>Denominación:</b> {{ registro.institucion_formadora }}</p>
        </div>
  
        <div class="header"><b>Oferta Cursada</b></div>
        <div class="info">
          <p><b>Folio: </b>-01-IEA-DCM-{{anio}}-{{registro.idregistro}}</p>
          <p><b>Nombre:</b> {{ registro.nombre_curso }}</p>
          <p><b>Tipo:</b> {{ registro.Oferta }}</p>
          <p><b>Duración:</b> {{ registro.horas }} hrs.</p>
          <p><b>Estatus:</b> {{ registro.resultado }}</p>
        </div>
  
        <p>**Esta información no sustituye a la constancia y se presenta sólo con fines de validación de la misma.</p>
      </div>
    </div>
  </template>
  
  <script>
  import { queryIEASIS } from "../components/backIeasis/dbContextConexion.js";
  
  export default {
    name: "ValidarQR",
  
    data() {
      return {
        registro: null,
        error: false,
        anio: '',
      };
    },
  
    created() {
      this.obtenerRegistroDB();
    },
    mounted() {
      const id = this.$route.query.id;
      console.log("ID recibido:", id);
    },
    methods: {
        async obtenerRegistroDB(){
      const id = this.$route.query.id;


      const obtenerHistorico = await this.obtenerConstanciaHistorica();
      const eshistotico = obtenerHistorico.historico;
     
      var query3="";
      switch (eshistotico) {
        case 0:
          query3 = "select r.idregistro, r.id_oferta, o.nombre_curso, o.descripcion,o.descripcion_det, o.fecha_ini, o.fecha_fin, ofe.nombre as Oferta, td.horas, " +
          "f.institucion_formadora, f.img, r.resultado, r.idusuario, u.usuario, " +
          "u.nombres, u.apellidop, u .apellidom " +
          " from registros r " +
          "INNER JOIN usuarios u ON r.idusuario = u.idusuario "+
          "INNER JOIN oferta_formacion o ON r.id_oferta = o.id_oferta "+
          "INNER JOIN instituciones_formadoras f ON o.institucion_formadora = f.idinstitucion "+
          "INNER JOIN tipos_oferta_det td ON  td.idofertadet = o.tipo_oferta "+
          "INNER JOIN tipos_oferta ofe ON ofe.idoferta = td.idoferta "+
          "INNER JOIN grupos g ON g.id_oferta = o.id_oferta " +
          "where r.idregistro=" + id
          break;
        case 1:
          
          query3 = "select TOP 1 r.idregistro, r.id_oferta, o.nombre_curso, o.descripcion,o.descripcion_det, o.fecha_ini, o.fecha_fin, ofe.nombre as Oferta, td.horas, "+
          "f.institucion_formadora, f.img, r.resultado, r.idusuario, u.usuario, "+
          "u.nombres, u.apellidop, u .apellidom "+
          "from registros r "+
          "INNER JOIN usuarios u ON r.idusuario = u.idusuario "+
          "INNER JOIN oferta_formacion o ON r.id_oferta = o.id_oferta "+
          "INNER JOIN instituciones_formadoras f ON o.institucion_formadora = f.idinstitucion "+
          "INNER JOIN tipos_oferta_det td ON  td.idofertadet = o.tipo_oferta "+
          "INNER JOIN tipos_oferta ofe ON ofe.idoferta = td.idoferta "+
          "where r.idregistro=" + id


          break;
        default:
          break;
      }
      const res3 = await queryIEASIS(query3)
      
      //VACIO DE VARIABLES RESPOONSE A OBJETO curso
      //curso.idregistro = (res2[0].idregistro)
      const curso= res3[0]
      const data = curso;


        if (!data) {
          this.error = true;
          return;
        }


        this.registro = data;        
        this.anio = this.registro.fecha_ini.substring(0,4)
    },


    async obtenerConstanciaHistorica(){
      const id = this.$route.query.id;
      const historico = "select historico from registros where idregistro=" + id
      const constHistorica = await queryIEASIS(historico)
      const data = constHistorica[0];
      return data;
    }

      
  
      
    },
  };
  </script>
  
  <style scoped>
  .logo {
    max-width: 240px;
    width: 100%;
  }
  
  .titulo {
    font-size: 1.2rem;
  }
  
  @media (max-width: 768px) {
    .titulo {
      font-size: 1rem;
    }
  }
  
  .header {
    font-weight: bold;
    margin-top: 20px;
    font-size: 18px;
  }
  
  .info p {
    margin: 5px 0;
  }
  </style>